<template>
    <div class="row" v-if="tooth">
        <div class="item">
            <component :width="width || 75 + 'px'" :readonly="readonly" v-model="parts.front" :is="frontToothLoader"></component>
        </div>
        <div class="item" v-if="!implant">
            <component :width="width || 75 + 'px'" :readonly="readonly" v-model="parts.oral" :is="oralToothLoader"></component>
        </div>
    </div>
</template>

<script>
export default {
    props: ['value', 'readonly', 'tooth', 'width', 'implant'],
    data() {
        return {
            parts: {
                front: {},
                oral: {}
            },

        }
    },

    created() {
    },
    computed: {
        frontToothLoader() {
            let tooth = this.tooth;
            if (typeof (tooth) == 'object') tooth = tooth.value;
            if (tooth > 50) {
                let map = {
                    55: 57,
                    54: 56,
                    64: 66,
                    65: 67,
                    74: 76,
                    75: 77,
                    84: 86,
                    85: 87,
                }
                if ([54, 55, 64, 65, 74, 75, 84, 85].indexOf(tooth) >= 0) {
                    tooth = tooth - 40;
                } else {
                    tooth = tooth - 40;
                }
            }
            if ( this.$settings.dentalChart === 'usa' )
                tooth = this.$usa2fdi(tooth);
            if (this.implant)
                return () => import(`@/components/Teeth/Implant/${tooth}`)   
            return () => import(`@/components/Teeth/Front/${tooth}`);
        },
        oralToothLoader() {
            let tooth = this.tooth;
            if (typeof (tooth) == 'object') tooth = tooth.value;
            tooth = tooth > 50 ? tooth - 40 : tooth;
            if ( this.$settings.dentalChart === 'usa' )
                tooth = this.$usa2fdi(tooth);
            if (this.implant)
                return () => import(`@/components/Teeth/Implant/${tooth}`)    
            return () => import(`@/components/Teeth/Oral/${tooth}`);
        },
    },
    mounted() {
        if (this.value) {
            Object.assign(this.parts, this.value);
        }
    },
    watch: {
        parts: {
            handler(newValue) {
                if (this.readonly) return false;
                this.$emit('input', newValue);
            },
            deep: true,
        },
        value(newValue) {
            Object.assign(this.parts, newValue);
        }
    },
    methods: {

    }
}
</script>

<style >
.svg-container {
  width: 10em;
}
 .active {
  fill: #EC8C9C;
  stroke: #EC8C9C;

}
.item{
    stroke: #95AAC9;
}
.item:hover {
  fill: #EBF1F6;

}
</style>
